import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectGlobalAlertData, setGlobalAlertData } from '../../redux/slicers/activitySlicer';
import styles from './GlobalAlertBar.module.scss';
import { useGlobalAlertBar } from '../../hooks/useGlobalAlertBar';

/**
 * Component: GlobalAlertBar
 * - React-safe version of the dynamic global alert banner.
 * - Watches `disasterMessage` in Redux and renders a top banner if active.
 * - Includes inline styles (same as previous DOM logic).
 * - Automatically animates in/out and allows manual close.
 */
const GlobalAlertBar = () => {
  const dispatch = useDispatch();
  const disasterMessage = useSelector(selectGlobalAlertData);
  const [visible, setVisible] = useState(false);

  useGlobalAlertBar();

  useEffect(() => {
    if (disasterMessage && (disasterMessage?.title || disasterMessage?.message)) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [disasterMessage]);

  if (!visible) return null;

  return (
    <div
      dataComponent="Global-Alert-Bar"
      className={styles.container}
      style={{
        color: disasterMessage?.text_color || '#fff',
        backgroundColor: disasterMessage?.background_color || '#EC4E0B',
        boxShadow: disasterMessage?.box_shadow || 'none',
      }}>
      {disasterMessage?.title && (
        <h5
          style={{
            textAlign: disasterMessage?.text_align || 'left',
            color: disasterMessage?.text_color || '#fff',
          }}>
          {disasterMessage?.title}
        </h5>
      )}
      {disasterMessage?.message && (
        <p
          style={{
            textAlign: disasterMessage?.text_align || 'left',
            color: disasterMessage?.text_color || '#fff',
          }}>
          {disasterMessage?.message}{' '}
          {disasterMessage?.link_text && disasterMessage?.link_url && (
            <a
              href={disasterMessage?.link_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: disasterMessage?.text_color || '#fff' }}>
              {disasterMessage?.link_text}
            </a>
          )}
        </p>
      )}

      <button
        className={styles.close}
        onClick={() => dispatch(setGlobalAlertData(''))}
        style={{
          color: disasterMessage?.text_color || '#fff',
        }}
        aria-label="Close alert"
        dangerouslySetInnerHTML={{
          __html: `<svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.88546 11.0911C10.2028 11.4004 10.729 11.4004 11.0463 11.0911C11.3636 10.7819 11.3636 10.269 11.0463 9.95976L6.98341 6L11.0463 2.04024C11.3636 1.731 11.3636 1.21811 11.0463 0.908871C10.729 0.59963 10.2028 0.599629 9.88546 0.908871L5.82258 4.86863L1.75963 0.908794C1.44233 0.599552 0.916087 0.599553 0.598793 0.908794C0.281498 1.21804 0.281497 1.73092 0.598792 2.04016L4.66175 6L0.598792 9.95983C0.281497 10.2691 0.281499 10.782 0.598792 11.0912C0.916086 11.4004 1.44233 11.4004 1.75963 11.0912L5.82258 7.13137L9.88546 11.0911Z"
              fill="currentColor"
            />
          </svg>`,
        }}
      />
    </div>
  );
};

export default GlobalAlertBar;
